import { axiosInstance } from "../../config";

export const getPowerBiEmbedToken = async (reportId: string) => {
  const data = await axiosInstance.post(`/embedtoken?ReportId=${reportId}`);
  return data.data;
};
